import { PunchupPoolDetails as PoolsComponent } from 'features/PunchupPages/PoolDetails';
import { PunchupPoolDetails as LegacyPoolsComponent } from 'features/PunchupPoolDetails';
import { ROUTES } from 'features/routes';
import { sendGAPage } from 'utils/utils';
import { useAppSelector } from 'store/hooks';
import { useEffect } from 'react';

const Pools = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);

	useEffect(() => {
		sendGAPage({ page: ROUTES.POOLS_NEW_PATH, title: 'Pools' });
	}, []);

	if (isPunchup && greenZoneEnabled) return <PoolsComponent />;
	return <LegacyPoolsComponent />;
};
export default Pools;
